'use client'

import { useState } from 'react'

import { Button } from '@/components/sections/button'
import { TextField } from '@/components/fields'

const baseState = { status: 'idle', error: '' }

function textareaClassName() {
  return 'block w-full appearance-none rounded-md border border-mid/60 bg-white px-3 py-2 text-dark placeholder-mid/70 focus:border-primary focus:bg-white focus:outline-hidden focus:ring-primary sm:text-sm'
}

export function ContactForm() {
  const [state, setState] = useState(baseState)

  async function handleSubmit(event) {
    event.preventDefault()
    if (state.status === 'sending') {
      return
    }

    setState({ status: 'sending', error: '' })

    const form = event.currentTarget
    const formData = new FormData(form)
    const payload = {
      'first-name': String(formData.get('first-name') || '').trim(),
      'last-name': String(formData.get('last-name') || '').trim(),
      first_name: String(formData.get('first_name') || '').trim(),
      last_name: String(formData.get('last_name') || '').trim(),
      email: String(formData.get('email') || '').trim(),
      enquiry: String(formData.get('enquiry') || '').trim(),
      website: String(formData.get('website') || '').trim(),
    }

    try {
      const response = await fetch('/api/contact', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      })

      const responseData = await response.json().catch(() => null)

      if (!response.ok || responseData?.ok === false) {
        throw new Error(responseData?.error || 'Something went wrong.')
      }

      setState({ status: 'success', error: '' })
      form.reset()
    } catch (error) {
      setState({
        status: 'error',
        error: error instanceof Error ? error.message : 'Something went wrong.',
      })
    }
  }

  return (
    <form onSubmit={handleSubmit} className="mt-10 grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-2">
      <TextField
        label="First name"
        name="first-name"
        type="text"
        autoComplete="given-name"
        required
      />
      <TextField
        label="Last name"
        name="last-name"
        type="text"
        autoComplete="family-name"
        required
      />
      <TextField
        className="col-span-full"
        label="Email address"
        name="email"
        type="email"
        autoComplete="email"
        required
      />
      <div className="col-span-full">
        <label htmlFor="enquiry" className="mb-3 block text-sm font-medium text-mid">
          Enquiry
        </label>
        <textarea
          id="enquiry"
          name="enquiry"
          rows={4}
          required
          className={textareaClassName()}
        />
      </div>
      <div className="sr-only">
        <label htmlFor="website">Website</label>
        <input id="website" name="website" type="text" tabIndex={-1} autoComplete="off" />
      </div>
      {state.status === 'success' ? (
        <p className="text-sm text-mid">Thanks — we&apos;ve received your enquiry.</p>
      ) : null}
      {state.status === 'error' ? <p className="text-sm text-red-600">{state.error}</p> : null}
      <div className="col-span-full">
        <Button
          type="submit"
          variant="solid"
          color="blue"
          className="w-full"
          disabled={state.status === 'sending'}
        >
          <span>
            Send enquiry <span aria-hidden="true">&rarr;</span>
          </span>
        </Button>
      </div>
    </form>
  )
}
